/**
 * The guides, listed — every one a link with what it answers under its title.
 */
import { Link } from 'react-router-dom';

import { useI18n } from '../i18n';
import { Seo } from '../components/Seo';
import { guidesEn } from '../guides/en';
import { guidesEs } from '../guides/es';
import { GUIDE_IDS } from '../guides/types';
import styles from '../components/GuideLayout.module.css';

export default function GuidesPage() {
  const { t, locale, localePath } = useI18n();
  const guides = locale === 'es' ? guidesEs : guidesEn;

  return (
    <>
      <Seo path="/guides" />
      <div className="container">
        <div className={styles.index}>
          <h1 className={styles.indexTitle}>{t.guides.title}</h1>
          <p className={styles.indexIntro}>{t.guides.intro}</p>
          <ul className={styles.cards}>
            {GUIDE_IDS.map((id) => (
              <li key={id}>
                <Link to={localePath(`/guides/${id}`)} className={styles.card}>
                  <h2 className={styles.cardTitle}>{guides[id].title}</h2>
                  <p className={styles.cardSummary}>{guides[id].summary}</p>
                  <span className={styles.cardRead} aria-hidden="true">
                    {t.guides.read} →
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
